// extracted by mini-css-extract-plugin
module.exports = {"logo":"logo-module--logo--3SmJE"};